module.exports = __webpack_public_path__ + "img/46ff2ee.jpg";